import {Col, Row} from "../../components/Flex/Flex.tsx";
import Icon from "../../components/Icon/Icon.tsx";
import IconMap from "../../components/Icon/IconMap.ts";
import {NumberInput, Paper} from "@mantine/core";
import {useState} from "react";
import {useEntityTypes} from "../../utils/api.ts";
import Label from "../../components/Label/Label.tsx";
import {MaterialType} from "../../types/swc.types.ts";


const YIELD_RAND_1 = 42.5;
const YIELD_RAND_2 = 50;


const getYield = (npc: number, material: MaterialType, morale: number, crime: number) => {

    return Math.round(((YIELD_RAND_1 / 100) + (npc/10)) * ((1500 * material.rarity / 100) * (morale+1) - (50 * crime) + YIELD_RAND_2));
}
const getBaseCost = (total: number, material: MaterialType, tax: number, crime: number, npc: number, management: number) => {
    return Math.round(total * material.cost + (total * material.cost * tax) + (0.2 * total * material.cost * crime) + 0.375 * 50000 * (Math.max(0, npc-1)) / (management+1))
}


export default function Mining() {
    const {materials} = useEntityTypes(['materials'], true);
    const [morale, setMorale] = useState<number|null>(90);
    const [crime, setCrime] = useState<number|null>(10);
    const [management, setManagement] = useState<number|null>(5);
    const [tax, setTax] = useState<number|null>(0);
    const [npc, setNpc] = useState<number|null>(12);


    return (
        <div className="w-full">
            <title>Mining Charts</title>
            <Row align="center">
                <Col><h1>Mining</h1></Col>
                <Col grow={1}/>
                <Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Mining" target="_blank"><Icon icon={IconMap.SwcRules}/> Full
                    rules</a></Col>
            </Row>
            <Row mb={3}>
                <Col>
                    <Label htmlFor="morale">Morale</Label>
                    <NumberInput id="morale" value={morale} onChange={setMorale} min={0} max={100} decimalScale={2} style={{width: 100}}/>
                </Col>
                <Col>
                    <Label htmlFor="crime">Crime</Label>
                    <NumberInput id="crime" value={crime} onChange={setCrime} min={0} max={100} style={{width: 100}} />
                </Col>
                <Col>
                    <Label htmlFor="management">Management</Label>
                    <NumberInput id="management" value={management} onChange={setManagement} min={0} max={5} style={{width: 80}}/>
                </Col>
                <Col>
                    <Label htmlFor="tax">Tax</Label>
                    <NumberInput id="tax" value={tax} onChange={setTax} min={0} max={100} style={{width: 100}} />
                </Col>
                <Col>
                    <Label htmlFor="npc">NPC</Label>
                    <NumberInput id="npc" value={npc} onChange={setNpc} min={1} max={15} style={{width: 80}} />
                </Col>

            </Row>

            <Paper>
                <table className="w-full">
                    <thead>
                    <tr>
                        <th>Material</th>
                        <th>Yield</th>
                        <th>Cost</th>
                        <th>Cost per unit</th>
                    </tr>
                    </thead>
                    {materials.map(rm => <MaterialRow
                            key={rm.id}
                            material={rm}
                            morale={(morale??0)/100}
                            crime={(crime??0)/100}
                            management={management??0}
                            tax={(tax??0)/100}
                            npc={npc??0}
                        />
                    )}
                </table>

            </Paper>
        </div>
    )
}


interface MaterialRowProps {
    material: MaterialType,
    morale: number,
    crime: number,
    management: number,
    tax: number,
    npc: number,
}


const formatter = new Intl.NumberFormat("en-US");
const MaterialRow = ({material, morale, crime, management, tax, npc}: MaterialRowProps) => {

    const y = getYield(npc, material, morale, crime);
    const cost = getBaseCost(y, material, tax, crime, npc, management);
    const costUnit = Math.round(cost / y);


    return (
        <tr>
            <td>{material.name}</td>
            <td className="text-right">{formatter.format(y)}</td>
            <td className="text-right">{formatter.format(cost)}</td>
            <td className="text-right">{formatter.format(costUnit)}</td>
        </tr>
    )

}
